import { pick } from 'lodash';
export function extractLessonMeta(lesson) {
    return {
        ...pick(lesson, ['id', 'name', 'description', 'coverSheet', 'tags', 'free', 'instructor']),
        steps: lesson.steps.map(extractLessonStepMeta)
    };
}
export function extractLessonStepMeta(step) {
    return pick(step, ['id', 'name', 'description']);
}
//# sourceMappingURL=LessonMeta.js.map